import { Component, Inject, OnInit } from '@angular/core';
import { Department, IdNameVM, WorkAreasByDepartmentVM } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-work-area-department-dialog',
  templateUrl: './edit-work-area-department-dialog.component.html',
  styleUrls: ['./edit-work-area-department-dialog.component.css']
})
export class EditWorkAreaDepartmentDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<EditWorkAreaDepartmentDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    this.getdepartmentlist();
    this.getAllWorkAreas();
  }
  inputValueDepartment
  inputValueWorkArea
  Allworklist:WorkAreasByDepartmentVM[]=[];
  Filteredworklist:WorkAreasByDepartmentVM[]=[];
  WorkList:IdNameVM[]=[];
  departmentlist:Department[];

  DialogClose(){
    this.dialogRef.close(false)
  }

  getdepartmentlist(){
    this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
    
    this.departmentlist=res.Departments;
    //this.worklist=res.WorkAreas;
    console.log( "departments",this.departmentlist)

    //get wrk Areas
  
   
    })
  }
  getAllWorkAreas(){
    this._safetyGeneraldashboardService.GetActiveWorkAreasForDropDownList().subscribe(res =>
      {
        console.log("workareas", res)
      
        this.Allworklist = res;
       
      });
  }


  GetActiveWorkAreasForDropDownListChanged()
  {
    if(this.Allworklist.length>0){
      this.Filteredworklist  =  this.Allworklist.filter(x=>x.DepartmentId == this.inputValueDepartment);
      this.WorkList  =  this.Filteredworklist[0].WorkAreas;
   
      console.log("department ID",this.inputValueDepartment)
      console.log("work list per department", this.Filteredworklist)
    }
  }



save()
{
  console.log('before InspctionID', this.data.InspectionID)
      console.log('before workaareaID', this.inputValueWorkArea)
  this._safetyGeneraldashboardService.SaveWorkArea(this.data.InspectionID, this.inputValueWorkArea).subscribe(res =>
    {
      console.log('before InspctionID', this.data.InspectionID)
      console.log('before workaareaID', this.inputValueWorkArea)
  });
  this.DialogClose();
}



}
